var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.99997,17.72449c0,4.71787-3.82023,8.5381-8.53118,8.5381c-4.71787,0-30.47143,0-32.34328,0   c-3.93159,0-7.12554-3.19395-7.12554-7.12554c0-3.93851,3.19395-7.1325,7.12554-7.1325c0.19482,0,0.38968,0.00697,0.58449,0.0209   c1.39867-4.4187,5.53901-7.62658,10.41696-7.62658c2.76252,0,5.28155,1.02293,7.20207,2.71385   c1.12036-1.21078,2.72778-1.96928,4.50916-1.96928c2.95041,0,5.42069,2.06671,6.02608,4.83619   c1.0925-0.50796,2.31721-0.79328,3.60452-0.79328C45.17974,9.18634,48.99997,13.00657,48.99997,17.72449z",
    fill: "#E7E3E6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.49665,21.47939H12.50329c-0.98596,0-1.78524,0.79928-1.78524,1.78524v3.10764    c0,0.98596,0.79928,1.78524,1.78524,1.78524h24.99336c0.98596,0,1.78524-0.79928,1.78524-1.78524v-3.10764    C39.28189,22.27866,38.48261,21.47939,37.49665,21.47939z",
    fill: "#656766"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 13.92914,
    cy: 24.81845,
    fill: "#EC6E62",
    r: 1.24103
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.23126,
    cy: 24.81845,
    fill: "#85BD57",
    r: 1.24103
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.53336,
    cy: 24.81845,
    fill: "#53B1E2",
    r: 1.24103
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.49665,30.2012H12.50329c-0.98596,0-1.78524,0.79928-1.78524,1.78524v3.10764    c0,0.98596,0.79928,1.78524,1.78524,1.78524h24.99336c0.98596,0,1.78524-0.79928,1.78524-1.78524v-3.10764    C39.28189,31.00048,38.48261,30.2012,37.49665,30.2012z",
    fill: "#656766"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 13.92914,
    cy: 33.54026,
    fill: "#EC6E62",
    r: 1.24103
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.23126,
    cy: 33.54026,
    fill: "#85BD57",
    r: 1.24103
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.53336,
    cy: 33.54026,
    fill: "#53B1E2",
    r: 1.24103
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#4E4C4D",
    height: 2.04369,
    width: 23.19548,
    x: 13.40223,
    y: 28.15751
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.49665,38.92301H12.50329c-0.98596,0-1.78524,0.79928-1.78524,1.78524v3.10764    c0,0.98596,0.79928,1.78524,1.78524,1.78524h24.99336c0.98596,0,1.78524-0.79928,1.78524-1.78524v-3.10764    C39.28189,39.72229,38.48261,38.92301,37.49665,38.92301z",
    fill: "#656766"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 13.92914,
    cy: 42.26207,
    fill: "#EC6E62",
    r: 1.24103
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.23126,
    cy: 42.26207,
    fill: "#85BD57",
    r: 1.24103
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.53336,
    cy: 42.26207,
    fill: "#53B1E2",
    r: 1.24103
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#4E4C4D",
    height: 2.04369,
    width: 23.19548,
    x: 13.40223,
    y: 36.87933
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackServer);
export default __webpack_public_path__ + "static/media/stack_server.4c6ac3d5e393a6b9577fd7271551ab89.svg";
export { ForwardRef as ReactComponent };